import { IArgumentType } from '../functions/utils';
import { InferenceError } from '../errors';
import { IFunctionToken } from '../typings/token';
import { isBoolean } from '../utils/type';


// 条件格式固定为：目标对象，比较符和参考值，目标对象/变量可以为变量、常量或函数返回值，不支持混合加减乘除运算，返回值为满足条件的参考值集合。
export function FILTER(args: IArgumentType[], token: IFunctionToken) {
  const functionName = token.formatName;

  if (args.length < 2) {
    throw new InferenceError('function-argument-error', `${functionName} 函数至少需要两个参数`, token.position);
  }

  const conditionArgs = args.slice(1);

  for (const arg of conditionArgs) {
    if (!isBoolean(arg)) {
      throw new InferenceError('function-argument-error', `${functionName} 函数第一个之后的参数返回类型都必须为布尔类型`, token.position);
    }
    if (!(arg as any).operator) {
      throw new InferenceError('function-argument-error', `${functionName} 函数条件参数必须为条件表达式`, token.position);
    }
  }

  return args[0];
}
